import React from 'react';
import { motion } from 'framer-motion';
import { bonos } from '../data/content';
export function BonosSection() {
  return <section id="incluye" className="w-full scroll-mt-16 bg-lavender px-5 py-12 sm:py-20" data-id="element-10" data-mp="185xjh68yb20v">
      <div className="mx-auto max-w-6xl" data-id="element-11" data-mp="13cw1gpdg6md2">
        <h2 className="mx-auto max-w-2xl text-center font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-12" data-mp="13bta6gc7qhwm">
          8 recursos para transformar una intención en una práctica real.
        </h2>

        <div className="mt-10 grid gap-4 sm:gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-13" data-mp="ogn63ywogt5x">
          {bonos.map((bono, i) => <motion.article key={bono.badge} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i % 4 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-2xl border border-aura/15 bg-card p-5" data-id="element-14" data-mp="kes40s6xabr3" data-mpi={i}>
              <div className="relative overflow-hidden rounded-xl bg-lavender/60" data-id="element-15" data-mp="qucxx2j74bg0">
                <img src={bono.coverImage} alt={`Portada de ${bono.title}`} width="900" height="675" loading="lazy" decoding="async" className="block aspect-[4/3] w-full object-cover" data-id="element-16" data-mp="vuramxvqs9kd" />
                <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gold/25" aria-hidden="true" data-id="element-17" data-mp="mtjfgooivoui" />
              </div>

              <span className="mt-4 text-[11px] font-bold uppercase tracking-wider text-aura" data-id="element-18" data-mp="1ak6xw3w2dwvb">
                {bono.badge}
              </span>
              <h3 className="mt-1.5 text-base font-bold leading-snug text-plum" data-id="element-19" data-mp="10tu7hv1kj9h9">{bono.title}</h3>
              <p className="mt-2 flex-1 text-[13px] leading-relaxed text-plum/75" data-id="element-20" data-mp="15sf6jr533n44">
                {bono.description}
              </p>
            </motion.article>)}
        </div>

        <p className="mx-auto mt-9 max-w-3xl rounded-2xl border border-gold/40 bg-card px-5 py-4 text-center text-sm font-medium leading-relaxed text-plum sm:text-base" data-id="element-21" data-mp="1tget0evd4rcw">
          Guía principal + Empezá acá + 8 recursos digitales · 10 archivos · 97 páginas visuales ·
          Acceso de por vida
        </p>
      </div>
    </section>;
}